module.exports = __webpack_public_path__ + "img/8.1fc58755.png";